// src/app/services/route-access.service.ts
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class RouteAccessService {
  private router = inject(Router);
  // Define a mapping of screen access types to their default routes
  // This should match your app.routes.ts data
  public readonly routeMap: { access: string; path: string }[] = [
    { access: 'RECS', path: '/' }, // Assuming '/' is the default for RECS
    { access: 'VOIDS', path: '/void' },
    { access: 'SETTINGS', path: '/settings' }, // Add if you have a settings page
    // Add other mappings as needed, in order of preference
  ];

  constructor() {}
  apiService = inject(ApiService);

  /**
   * Finds the first accessible route based on the user's screen access.
   * @param userScreenAccess The array of screen access permissions the user has.
   * @returns The path of the first accessible route, or null if none found.
   */
  // findFirstAccessibleRoute(userScreenAccess: string[]): string | null {
  //   for (const mapping of this.routeMap) {
  //     if (userScreenAccess.includes(mapping.access) || userScreenAccess.includes('ALL')) {
  //       return mapping.path;
  //     }
  //   }
  //   return null; // No accessible route found
  // }

  findFirstAccessibleRoute(userScreenAccess: string): string | null {
    if (userScreenAccess === 'ALL') {
      return this.routeMap.length > 0 ? this.routeMap[0].path : null;
    }
    for (const mapping of this.routeMap) {
      if (userScreenAccess === mapping.access) {
        return mapping.path;
      }
    }
    return null; // No accessible route found
  }

  /**
   * Checks if a user has access to a specific route based on its required screen access.
   * @param userScreenAccess The array of screen access permissions the user has.
   * @param requiredAccess The array of screen access permissions required by the route.
   * @returns True if the user has access, false otherwise.
   */
  hasAccessToRoute(userScreenAccess: string[], requiredAccess: string[]): boolean {
    if (!requiredAccess || requiredAccess.length === 0) {
      return true; // No specific access required, so allow
    }
    return requiredAccess.some((access) => userScreenAccess.includes(access) || userScreenAccess.includes('ALL'));
  }

  redirectToDefaultPage(userScreenAccess: string[]): void {
    // Use the shared service to find the target path
    let bottlerDefaultScreen: any;
    this.apiService.getBottlerDefaultScreen().subscribe(
      (data: any) => {
        bottlerDefaultScreen = data.data.bottler_default_screen;
        const targetPath = this.findFirstAccessibleRoute(bottlerDefaultScreen);
        if (targetPath) {
          // Only navigate if the current path is different from the target path
          if (this.router.url !== targetPath) {
            console.log(`Redirecting user from ${this.router.url} to ${targetPath} based on screen access.`);
            this.router.navigateByUrl(targetPath);
          } else {
            console.log(`User is already on the correct page (${targetPath}). No redirect needed.`);
          }
        } else {
          // Fallback if no accessible route is found (e.g., user has no permissions at all)
          console.warn('No accessible route found for the user. Redirecting to /access-denied.');
          this.router.navigateByUrl('/access-denied'); // Ensure this route/component exists
        }
      },
      (error) => {
        console.error('Failed to fetch bottler defaultscreen:', error);
        bottlerDefaultScreen = userScreenAccess;
      },
    );
  }
}
